const Kannada = {
  //COMMON
  nameRequired: "ಹೆಸರು ಅಗತ್ಯವಿದೆ.",
  firstNameRequired: "ಮೊದಲ ಹೆಸರು ಅಗತ್ಯವಿದೆ.",
  lastNameRequired: "ಕೊನೆಯ ಹೆಸರು ಅಗತ್ಯವಿದೆ.",
  phoneRequired: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ.",
  emailRequired: "ಇಮೇಲ್ ಅಗತ್ಯವಿದೆ.",
  genderRequired: "ಲಿಂಗ ಅಗತ್ಯವಿದೆ.",
  dobRequired: "ಹುಟ್ಟಿದ ದಿನಾಂಕ ಅಗತ್ಯವಿದೆ.",
  firstNamelength: "ಮೊದಲ ಹೆಸರು ಕನಿಷ್ಠ 3 ಅಕ್ಷರಗಳಿರಬೇಕು.",

  experienceRequired: "ಅನುಭವ ಅಗತ್ಯವಿದೆ.",
  suggestionRequired: "ಸಲಹೆ ಅಗತ್ಯವಿದೆ.",
  onlyAlphabetsAllowed: "ಅಕ್ಷರಗಳು ಮತ್ತು ಖಾಲಿ ಜಾಗ ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ.",

  //PROFILE
  pincodeRequired: "ಮಾನ್ಯ 6 ಅಂಕಿಯ ಪಿನ್‌ಕೋಡ್ ಅಗತ್ಯವಿದೆ.",
  stateRequired: "ರಾಜ್ಯ ಅಗತ್ಯವಿದೆ.",
  districtRequired: "ಜಿಲ್ಲೆ ಅಗತ್ಯವಿದೆ.",
  cityRequired: "ನಗರ/ಪಟ್ಟಣ/ಗ್ರಾಮ ಅಗತ್ಯವಿದೆ.",
  addressRequired: "ವಿಳಾಸ ಅಗತ್ಯವಿದೆ.",
  religionRequired: "ಧರ್ಮ ಅಗತ್ಯವಿದೆ.",
  templeFrequencyRequired: "ದೇವಾಲಯ ಭೇಟಿ ಅವಶ್ಯಕತೆಯಾಗಿದೆ.",
  languageRequired: "ಭಾಷೆ ಅಗತ್ಯವಿದೆ.",
  phoneTenDigits: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ 10 ಅಂಕಿಗಳಾಗಿರಬೇಕು.",
  phonestarts:"ಸಂಖ್ಯೆ 0 ರಿಂದ ಆರಂಭವಾಗಬಾರದು.",
  aadharInvalid: "ಆಧಾರ್ ಸಂಖ್ಯೆ 12 ಅಂಕಿಗಳಾಗಿರಬೇಕು.",
  passportInvalid:
    "ಪಾಸ್‌ಪೋರ್ಟ್ ಸಂಖ್ಯೆ 1 ಅಕ್ಷರ ಮತ್ತು 7 ಅಂಕಿಗಳಾಗಿರಬೇಕು (ಉದಾ: K1234567).",
  firstNameInvalid:
    "ಮೊದಲ ಹೆಸರು ಅಕ್ಷರಗಳು ಮತ್ತು ಖಾಲಿ ಸ್ಥಳಗಳನ್ನು ಮಾತ್ರ ಹೊಂದಿರಬೇಕು.",
  lastNameInvalid:
    "ಕೊನೆಯ ಹೆಸರು ಅಕ್ಷರಗಳು ಮತ್ತು ಖಾಲಿ ಸ್ಥಳಗಳನ್ನು ಮಾತ್ರ ಹೊಂದಿರಬೇಕು.",

  // PASSWORD
  currentPasswordRequired: "ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್ ಅಗತ್ಯವಿದೆ.",
  newPasswordRequired: "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಅಗತ್ಯವಿದೆ.",
  confirmPasswordRequired: "ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಣ ಅಗತ್ಯವಿದೆ.",
  currentPasswordInvalid:
    "ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್ ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳಿರಬೇಕು ಮತ್ತು ಅದರಲ್ಲಿ ಒಂದು ದೊಡ್ಡ ಅಕ್ಷರ, ಒಂದು ಸಣ್ಣ ಅಕ್ಷರ, ಒಂದು ಸಂಖ್ಯೆ ಮತ್ತು ಒಂದು ವಿಶೇಷ ಚಿಹ್ನೆ ಇರಬೇಕು.",
  newPasswordInvalid:
    "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳಿರಬೇಕು ಮತ್ತು ಅದರಲ್ಲಿ ಒಂದು ದೊಡ್ಡ ಅಕ್ಷರ, ಒಂದು ಸಣ್ಣ ಅಕ್ಷರ, ಒಂದು ಸಂಖ್ಯೆ ಮತ್ತು ಒಂದು ವಿಶೇಷ ಚಿಹ್ನೆ ಇರಬೇಕು.",
  confirmPasswordInvalid:
    "ದೃಢೀಕರಣ ಪಾಸ್ವರ್ಡ್ ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳಿರಬೇಕು ಮತ್ತು ಅದರಲ್ಲಿ ಒಂದು ದೊಡ್ಡ ಅಕ್ಷರ, ಒಂದು ಸಣ್ಣ ಅಕ್ಷರ, ಒಂದು ಸಂಖ್ಯೆ ಮತ್ತು ಒಂದು ವಿಶೇಷ ಚಿಹ್ನೆ ಇರಬೇಕು.",
  passwordsNotMatch: "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಮತ್ತು ದೃಢೀಕರಣ ಪಾಸ್ವರ್ಡ್ ಹೊಂದಿಲ್ಲ.",
  emojiNotAllowed:"ಪಾಸ್ವರ್ಡ್‌ನಲ್ಲಿ ಇಮೋಜಿಗಳನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.",
  incorrectCurrentPassword: "ನೀವು ನಮೂದಿಸಿದ ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್ ತಪ್ಪಾಗಿದೆ.",
  sameAsCurrentPassword:
    "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್ ಜೊತೆ ಸಮಾನವಾಗಿರಲು ಸಾಧ್ಯವಿಲ್ಲ.",

  //IMAGE
  fileTooLarge: "ಫೈಲ್ ಗಾತ್ರವು 2MB ಮೀರಬಾರದು.",
  invalidFileType:
    "ಅಮಾನ್ಯ ಫೈಲ್ ಪ್ರಕಾರ. ದಯವಿಟ್ಟು JPG/JPEG ಅಥವಾ PNG ಚಿತ್ರವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
  imageUploadFailed: "ಚಿತ್ರ ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
};

export default Kannada;
